// packages/app/src/scaffolder/AzureDevOpsProjectPicker/extensions.ts

import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { AzureDevOpsProjectPicker } from './AzureDevOpsProjectPickerExtension';
import { AzureDevOpsRepositoryPicker } from './AzureDevOpsRepositoryPickerExtension';
import { AzureDevOpsBranchPicker } from './AzureDevOpsBranchPickerExtension';
import {
  azureDevOpsProjectPickerValidation,
  azureDevOpsRepositoryPickerValidation,
  azureDevOpsBranchPickerValidation,
} from './validation';

/**
 * Extension para el selector de proyectos de Azure DevOps
 */
export const AzureDevOpsProjectPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AzureDevOpsProjectPicker',
    component: AzureDevOpsProjectPicker,
    validation: azureDevOpsProjectPickerValidation,
  }),
);

export const AzureDevOpsRepositoryPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AzureDevOpsRepositoryPicker',
    component: AzureDevOpsRepositoryPicker,
    validation: azureDevOpsRepositoryPickerValidation,
  }),
);

export const AzureDevOpsBranchPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AzureDevOpsBranchPicker',
    component: AzureDevOpsBranchPicker,
    validation: azureDevOpsBranchPickerValidation,
  }),
);
  